import { useRef } from 'react';
import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import Checkbox from 'components/form-elements/checkbox/Checkbox';
import Icon from 'components/icon/Icon';

import { IFilterGroup } from 'source/NFR.types';

interface IFilterGroupProps extends IFilterGroup {
  isDesktop: boolean;
  dataId?: number;
  updateFilterOptions: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FilterGroup: React.FC<IFilterGroupProps> = ({
  accordion,
  options = [],
  title,
  updateFilterOptions,
  isDesktop,
  dataId
}) => {
  const container = useRef<HTMLDivElement>(null);

  return !isDesktop ? (
    <Accordion {...accordion} buttonTextForLabel={title}>
      {({ Button: AccordionButton, Collapse, isOpen, toggle }) => (
        <div className="filter-group" ref={container}>
          <AccordionButton className="filter-group--header" onClick={toggle}>
            <h2 className="filter-group--header-title">
              <span> {title}</span>
              <Icon
                className={cn('filter-group--icon', {
                  'filter-group--icon--is-open': isOpen
                })}
                name="small-arrow-down"
                fill={true}
              />
            </h2>
          </AccordionButton>

          <Collapse>
            <div className="filter-group__content">
              <ul className="filter-group--options">
                {options?.map(option => (
                  <li key={option.value}>
                    <Checkbox onChange={updateFilterOptions} dataId={dataId} isControlled {...option} />
                    {option.subOptions && (
                      <ul className="filter-group--sub-options">
                        {option.subOptions?.map(subOption => (
                          <li key={subOption.value}>
                            <Checkbox onChange={updateFilterOptions} dataId={dataId} isControlled {...subOption} />
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </Collapse>
        </div>
      )}
    </Accordion>
  ) : (
    <div className="filter-group-open">
      <div className="filter-group-open__content">
        {title && <div className="filter-group-open__title">{title}</div>}
        <ul className="filter-group-open--options">
          {options?.map(option => (
            <li key={option.value}>
              <Checkbox onChange={updateFilterOptions} dataId={dataId} isControlled {...option} />
              {option.subOptions && (
                <ul className="filter-group-open--sub-options">
                  {option.subOptions?.map(subOption => (
                    <li key={subOption.value}>
                      <Checkbox onChange={updateFilterOptions} dataId={dataId} isControlled {...subOption} />
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

FilterGroup.displayName = 'FilterGroup';

export default FilterGroup;
